// extracted by mini-css-extract-plugin
module.exports = {"title":"AccessCheckerPopup_title__Q-if6","message":"AccessCheckerPopup_message__1M-qE","btnsWrapper":"AccessCheckerPopup_btnsWrapper__1ouOz"};